var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'UIElement',
    _vm.$style.NavigationItem,
    _vm.match && _vm.match.active && _vm.$style.NavigationItem__active,
    _vm.match && _vm.match.exact && _vm.$style.NavigationItem__exactActive
  ],on:{"click":function($event){return _vm.onClick(_vm.item)}}},[(_vm.item.icon)?_c('Icon',{class:_vm.$style.NavigationItem_icon,attrs:{"icon":_vm.item.icon}}):_vm._e(),_c('span',{class:_vm.$style.NavigationItem_label},[_vm._v(_vm._s(_vm.item.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }